var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"doc_view"}},[_c('iframe',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],attrs:{"src":_vm.pdfData}})])
}
var staticRenderFns = []

export { render, staticRenderFns }